import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { label: 'New conversations', icon: '✨', route: '/chat' },
    { label: 'Discover Careers', icon: '🎯', route: '/discover-careers-loader' },
    { label: 'Career Progress', icon: '📍', route: '/career-progress-loader' },
    { label: 'Recommended Skills', icon: '🔥', route: '/recommended-skills-loader' },
    { label: 'Career Transition', icon: '💼', route: '/career-transition-loader' },
    { label: 'Career Videos (YT)', icon: '🎬', route: '/career-videos-loader' },
    { label: 'Learn & Grow', icon: '📚', route: '/learn-and-grow-loader' },
    { label: 'Soft Skills', icon: '🗣️', route: '/soft-skills-loader' },
    { label: 'Startup Ideas', icon: '🚀', route: '/startup-loader' },
    { label: 'Daily Quote / Journal', icon: '📝', route: '/daily-quote-loader' },
    { label: 'Your Future Self', icon: '🎨', route: '/future-self-loader' },
  ];

  return (
    <div className="w-72 md:w-80 h-screen overflow-y-auto rounded-3xl bg-white/70 backdrop-blur-lg p-6 flex flex-col gap-3 shadow-md">
      {menuItems.map((item, index) => {
        const mainPath = item.route?.replace('-loader', '');
        const isActive =
          location.pathname === item.route || location.pathname === mainPath;

        return (
          <div
            key={index}
            onClick={() => item.route && navigate(item.route)}
            className={`flex items-center gap-4 px-4 py-3 rounded-2xl transition-all duration-200 cursor-pointer 
              ${isActive ? 'bg-orange-300/50 font-bold' : 'hover:bg-orange-200'}`}
          >
            <span className="text-2xl">{item.icon}</span>
            <span className="text-stone-800 text-base font-medium font-['Sora'] leading-tight">
              {item.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default Sidebar;
